import React, { useCallback, useState } from 'react';
import { Route, RouteProps, Switch } from 'react-router-dom';

import Breadcrumbs from '../components/Navigation/Breadcrumbs';
import Header from '../components/Header';
import MouseActivityDetector from '../components/MouseActivityDetector';
import Navigation from '../components/Navigation';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes';
import { ToastContainer } from 'react-toastify';
import classNames from 'classnames';
import { isAdmin } from '../components/utils/CommonFunction';
import styles from '../components/Layout/Layout.module.scss';
import { useAuth } from 'oidc-react';

export default function AppRouter() {
  const [isShowLeftMenu, setIsShowLeftMenu] = useState(false);

  const auth = useAuth();

  const onShowHideLeftMenu = useCallback(() => {
    setIsShowLeftMenu(!isShowLeftMenu);
  }, [isShowLeftMenu]);

  function renderRoute(props: RouteProps, i: number) {
    return <Route key={i} {...props} />;
  }

  const renderRoutes = () => (
    <div
      className={classNames(styles.bodyContent, {
        [styles.adminBodyContent]: isAdmin()
      })}>
      <aside
        id="leftSideMenu"
        className={classNames(styles.leftSideMenu, {
          [styles.show]: isShowLeftMenu
        })}>
        <Navigation onClickMenuItem={onShowHideLeftMenu} />
      </aside>
      <div
        className={classNames(styles.leftSideMenuMask, {
          [styles.showLeftSideMenuMask]: isShowLeftMenu
        })}
        onClick={onShowHideLeftMenu}></div>
      <Switch>{Routes.map(renderRoute)}</Switch>
    </div>
  );

  return (
    <Router>
      <div
        className={classNames('vh-100 overflow-x-hidden', styles.appWrapper, {
          [styles.menuShowing]: isShowLeftMenu
        })}>
        {auth.userData ? (
          <>
            <Header onShowHideLeftMenu={onShowHideLeftMenu} />
            {isAdmin() && <Breadcrumbs />}
            {renderRoutes()}
          </>
        ) : (
          <Switch>{Routes.map(renderRoute)}</Switch>
        )}
      </div>
      <MouseActivityDetector />
      <ToastContainer />
    </Router>
  );
}
